import { baseApi, ENDPOINTS } from '@/shared/api';

import type { SessionData, RevokeSessionBody } from '../model/types';

const sessionApi = baseApi
    .enhanceEndpoints({ addTagTypes: ['SessionData'] })
    .injectEndpoints({
        endpoints: (build) => ({
            getSessions: build.query<SessionData[], void>({
                query: () => ENDPOINTS.session.list,
                providesTags: ['SessionData'],
            }),
            revokeSession: build.mutation<void, RevokeSessionBody>({
                query: (body) => ({
                    url: ENDPOINTS.session.revoke,
                    method: 'POST',
                    body,
                }),
                invalidatesTags: ['SessionData'],
            }),
            revokeAllOtherSessions: build.mutation<void, void>({
                query: () => ({
                    url: ENDPOINTS.session.revokeAll,
                    method: 'POST',
                }),
                invalidatesTags: ['SessionData'],
            }),
        }),
    });

export const {
    useGetSessionsQuery,
    useRevokeSessionMutation,
    useRevokeAllOtherSessionsMutation,
} = sessionApi;
